import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SvgIconComponent } from '../svg-icons/svg-icon.component';
import { ISearchProvider } from './search-provider.interface';

@Component({
  selector: 'app-search-input',
  imports: [CommonModule, MatRippleModule, ReactiveFormsModule, SvgIconComponent],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss',
})
export class SearchInputComponent {
  placeholder = input('キーワードで検索...');
  searchProvider = input.required<ISearchProvider>();
  control = input.required<FormControl<string | null>>();

  onClickSearch(event: MouseEvent | SubmitEvent) {
    event.preventDefault();
    console.log(this.searchProvider());
    this.searchProvider()!.onClickSearch();
  }

  onClickClear() {
    this.searchProvider()!.onClickClear();
    this.control().reset();
  }
}
